import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'

const Additional_Information = () => {
  const classes = useStyles()
  return (
    <Box className={'section'}>
      <Typography variant="h4">
        Additional information about Data collection and processing
      </Typography>

      <Typography variant="h5">Legal action</Typography>
      <Typography>
        The User's Personal Data may be used for legal purposes by the Owner in
        Court or in the stages leading to possible legal action arising from
        improper use of this Application or the related Services. The User
        declares to be aware that the Owner may be required to reveal personal
        data upon request of public authorities.
      </Typography>

      <Typography variant="h5">
        Additional information about User's Personal Data
      </Typography>
      <Typography>
        In addition to the information contained in this privacy policy, this
        Application may provide the User with additional and contextual
        information concerning particular Services or the collection and
        processing of Personal Data upon request.
      </Typography>

      <Typography variant="h5">System logs and maintenance</Typography>
      <Typography>
        For operation and maintenance purposes, this Application and any
        third-party services may collect files that record interaction with this
        Application (System logs) use other Personal Data (such as the IP
        Address) for this purpose.
      </Typography>

      <Typography variant="h5">
        Information not contained in this policy
      </Typography>
      <Typography>
        More details concerning the collection or processing of Personal Data
        may be requested from the Owner at any time. Please see the contact
        information at the beginning of this document.
      </Typography>

      <Typography variant="h5">
        How “Do Not Track” requests are handled
      </Typography>
      <Typography>
        This Application does not support “Do Not Track” requests. To determine
        whether any of the third-party services it uses honor the “Do Not Track”
        requests, please read their privacy policies.
      </Typography>

      <Typography variant="h5">Changes to this privacy policy</Typography>
      <Typography>
        The Owner reserves the right to make changes to this privacy policy at
        any time by notifying its Users on this page and possibly within this
        Application and/or - as far as technically and legally feasible -
        sending a notice to Users via any contact information available to the
        Owner. It is strongly recommended to check this page often, referring to
        the date of the last modification listed at the bottom.
      </Typography>

      <Typography variant="body1">
        Should the changes affect processing activities performed on the basis
        of the User’s consent, the Owner shall collect new consent from the
        User, where required.
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles((theme) => createStyles({}))

export default Additional_Information
